<template>
  <div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data () {
    return {}
  },
  watch: {},
  computed: {},
  methods: {
    close () {
      this.$store.commit('setFlag', 'false')
      this.$store.commit('setOrder', '')
      this.$store.commit('setOpenId', '')
      this.$store.commit('setType', 'recharge')
      this.$store.commit('setFindType', '')
      this.$store.commit('setIsFirst', '')
      this.$store.commit('setVersionTime', new Date().getTime())
      const that = this
      setTimeout(_ => {
        that.$router.go(-1)
      }, 10)
    }
  },
  beforeCreate () {},
  created () {
    this.close()
  },
  mounted () {}
}
</script>

<style scoped lang='less'>
</style>
